const calculatorSelector = 'teka-room-order-calculator';

function updateRoomCalculator(calculator, changedField) {
  const areaInput = calculator.querySelector('[data-room-area]');
  const tileInput = calculator.querySelector('[data-room-unit-quantity]');
  const wastageInput = calculator.querySelector('[data-room-wastage]');
  const coverage = Number(calculator.dataset.coverage) || 0;
  const price = Number(calculator.dataset.priceCents) || 0;
  const wastage = Number(wastageInput?.value) || 0;
  const wastageMultiplier = 1 + wastage / 100;

  if (changedField?.matches('[data-room-area]')) {
    calculator.dataset.roomInputMode = 'area';
  } else if (changedField?.matches('[data-room-unit-quantity]')) {
    calculator.dataset.roomInputMode = 'quantity';
  }

  const quantityMode = Boolean(tileInput) && calculator.dataset.roomInputMode === 'quantity';
  let area = Number(areaInput?.value) || 0;
  let units;

  if (quantityMode) {
    units = Math.max(0, Math.floor(Number(tileInput.value) || 0));
    area = coverage > 0 && units > 0 ? Number(((units * coverage) / wastageMultiplier).toFixed(2)) : 0;
    if (areaInput) areaInput.value = area.toFixed(2);
  } else {
    units = coverage > 0 ? Math.ceil(((area * wastageMultiplier) / coverage) - 1e-9) : 0;
    if (tileInput) tileInput.value = String(units);
  }

  const hasInput = quantityMode ? units > 0 : area > 0;
  const requiredArea = area * wastageMultiplier;
  const purchasedArea = units * coverage;
  const total = units * price / 100;
  calculator.dataset.units = String(units);

  const areaTotal = calculator.querySelector('[data-room-area-total]');
  const unitTotal = calculator.querySelector('[data-room-pack-total]');
  const purchasedAreaTotal = calculator.querySelector('[data-room-purchased-area]');
  const priceTotal = calculator.querySelector('[data-room-total]');
  const unitLabel = calculator.dataset.unitLabel || 'pack';
  const unitLabelPlural = calculator.dataset.unitLabelPlural || `${unitLabel}s`;

  if (areaTotal) areaTotal.textContent = hasInput ? `${requiredArea.toFixed(2)} m²` : '— m²';
  if (unitTotal) unitTotal.textContent = hasInput ? `${units} ${units === 1 ? unitLabel : unitLabelPlural}` : '—';
  if (purchasedAreaTotal) purchasedAreaTotal.textContent = hasInput ? `${purchasedArea.toFixed(2)} m²` : '— m²';
  if (priceTotal) {
    priceTotal.textContent = hasInput
      ? new Intl.NumberFormat('en-GB', { style: 'currency', currency: calculator.dataset.currency || 'GBP' }).format(total)
      : '—';
  }

  const productDetails = calculator.closest('.product-details');
  const productForm = productDetails?.querySelector('product-form-component');
  const quantityInput =
    productForm?.querySelector('quantity-selector-component input[name="quantity"]') ??
    productForm?.querySelector('input[name="quantity"]') ??
    productDetails?.querySelector('input[name="quantity"]');

  if (quantityInput) {
    quantityInput.value = hasInput ? String(units) : quantityInput.min || '1';
    quantityInput.dispatchEvent(new Event('input', { bubbles: true }));
    quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
    quantityInput.closest('quantity-selector-component')?.updateButtonStates?.();
  }

  const whatsappButton = productDetails?.querySelector('[data-room-quote]');
  if (whatsappButton) {
    const productTitle = calculator.dataset.productTitle || '';
    const message = !hasInput
      ? `Hi TEKA, best price on ${productTitle} please.`
      : quantityMode
        ? `Hi TEKA, best price on ${productTitle} please — ${units} ${units === 1 ? unitLabel : unitLabelPlural} (${purchasedArea.toFixed(2)} m²).`
        : `Hi TEKA, best price on ${productTitle} please — ${area.toFixed(1)} m²${wastage ? ' plus 10% wastage' : ''}, ${units} ${units === 1 ? unitLabel : unitLabelPlural}.`;
    whatsappButton.href = `${calculator.dataset.whatsappEndpoint}?text=${encodeURIComponent(message)}`;
  }

  const basketButton = productDetails?.querySelector('.add-to-cart-button');
  if (basketButton && !basketButton.disabled) {
    const textNode = [...basketButton.childNodes].find(
      (node) => node.nodeType === Node.TEXT_NODE && node.textContent.trim(),
    );
    if (textNode) {
      textNode.textContent = hasInput
        ? `Add ${units} ${units === 1 ? unitLabel : unitLabelPlural} to basket`
        : 'Add to basket';
    }
  }
}

function handleRoomCalculatorInput(event) {
  const target = event.target;
  if (!(target instanceof HTMLInputElement || target instanceof HTMLSelectElement)) return;

  const calculator = target.closest(calculatorSelector);
  if (!calculator) return;
  if (
    !target.matches('[data-room-area]') &&
    !target.matches('[data-room-unit-quantity]') &&
    !target.matches('[data-room-wastage]')
  ) return;

  updateRoomCalculator(calculator, target);
}

document.addEventListener('input', handleRoomCalculatorInput);
document.addEventListener('change', handleRoomCalculatorInput);
